module.exports = "/images/banner-03.jpg?78a1db9129db6e390a149f8ef45faf14";